import getActiveFilters from './getActiveFilters';

// Get all of the non-default filter values and convert them into query parameter format
export default (filterState) => {
    /* Here activeFilters refers to filters whose values differ from the default - we're removing all of the filter
     * names for the filters that need special treatment. */
    // Make a dictionary of the filter names with their values
    const activeFilters = getActiveFilters(filterState);
    const params = Object.entries(activeFilters)
        .filter(([key, _]) => key !== 'customFilters')
        .map(([filter, value]) => `${filter}=${value}`);

    // Handle customFilters -- cF is an array of objects so let's reformat them accordingly
    // (i.e. filter=gamesPlayed,gte,1)
    if (filterState.values.customFilters) {
        filterState.values.customFilters
            .filter((filter) => filter.value !== undefined && filter.value !== '')
            .forEach((filter) => {
                params.push(`filter=${filter.measure},${filter.operator},${filter.value}`);
            });
    }

    return params;
};
